import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '@coolblue-development/freddy';
import { ArrowRight } from '@coolblue-development/icons';
export const LinkToSection = ({ title, anchor }) => {
    if (!title || !anchor)
        return null;
    return (_jsx(Link, { href: `#${anchor}`, startIcon: _jsx(ArrowRight, {}), children: title }));
};
//# sourceMappingURL=LinkToSection.js.map